import React from "react";
import Overview from "./Overview";
import Add from "./Add";
import Edit from "./Edit";

import { PositionProvider } from "../../../context/PositionContext";

export const Dances = () => {
  return (
    
      <PositionProvider>
        <Overview />
      </PositionProvider>
    
  );
};

export const AddDance = () => {
  return (
    
      
        <Add />
      
    
  );
};

export const EditDance = () => {
  return (
    
      
        <Edit />
      
    
  );
};
